import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as BS from 'react-bootstrap';
import * as Resource from '../../../apis/SpreadsheetReportConfigs';
import { convertCamelCaseKeys } from '../../../lib/objectUtils';

const scope =
  'frontend.components.SpreadsheetReportConfigs.Modal.PreviewOutputDataModal';

const propTypes = {
  content: PropTypes.string,
  period: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

const PreviewOutputStringDataModal = ({
  content,
  period,
  startDate,
  endDate,
}) => {
  const [show, setShow] = useState(false);
  const [previewData, setPreviewData] = useState(null);

  const onHide = () => {
    setShow(false);
  };

  const handlePreview = () => {
    const matchResult = location.pathname.match(/\/projects\/(\d+)/);
    if (!matchResult) {
      return;
    }
    const [, projectId] = matchResult;
    const previewPayload = {
      period,
      startDate,
      endDate,
      panels: {
        type: 'string',
        content,
      },
    };
    Resource.getPanelPreviewData(projectId, previewPayload).then((response) => {
      const convertedCamelCaseData = convertCamelCaseKeys(response.data);
      setShow(true);
      setPreviewData(convertedCamelCaseData.previewData);
    });
  };

  return (
    <>
      <BS.Button
        bsStyle='primary'
        onClick={() => handlePreview()}
        disabled={!content.trim()}
      >
        {I18n.t(`${scope}.action.preview`)}
      </BS.Button>

      <BS.Modal show={show} onHide={onHide}>
        <BS.Modal.Header closeButton>
          <BS.Modal.Title>{I18n.t(`${scope}.header.title`)}</BS.Modal.Title>
        </BS.Modal.Header>

        <BS.Modal.Body>
          <div style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
            {previewData}
          </div>
        </BS.Modal.Body>
      </BS.Modal>
    </>
  );
};

PreviewOutputStringDataModal.propTypes = propTypes;

export default PreviewOutputStringDataModal;
